///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promo = abcsetup.promo || {};
abcsetup.promo.workflow = abcsetup.promo.workflow || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promo.items = {};

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promo.workflow = {
    init: function () {
        abcsetup.setTitle('Review Promotion Items');
        this.initListeners();
    },
    initListeners: () => {

        if ($('#promo_type').length) {
            var promo_type = JSON.parse($('#promo_type').text());
        }

        if (promo_type && promo_type.is_gnp_type) {
            console.log('its a gnp type!');
            abcsetup.promos.gnp.common.init();
            return true;
        }

        var role = abcsetup.userRole.class != 'fs_cm' ? abcsetup.userRole.class : 'cm';

        $(function() {
            $('.reject_reason').hide();
            $('.approve_fields').hide();
            $('.btn-approve').prop('disabled', true);
        });

        $(document).on('keyup', '.cost_cm_proposed', function () {
            if ($(this).val() > 0) {
                $(this).next('div.cost_cm_proposed_comment').show().find('.approve_promo_item_comments').prop('required', true);
            } else {
                $(this).next('div.cost_cm_proposed_comment').hide().find('.approve_promo_item_comments').prop('required', false);
            }
        });

        // Approval all button clicked
        $(document).on('click', '.send_notification', function () {
            if ($('#send_notifications').is(':visible')) {
                $('#send_notifications').hide();
            }
            else {
                $('#send_notifications').show();
            }

        });

        $(document).on('click', '#mark_all_reassign', function () {
            const elem = $(this);
            abcsetup.promo.workflow.markAllReassign(elem,role);
        });

        // Approval all button clicked
        $(document).on('click', '#btn-approve-all', function () {
            $('input:radio[value="Y"]').trigger('click');
            $('.btn-approve').prop('disabled', false);
        });

        $(document).on('click', '.mark_all_block_items_approved', function() {
            $(this).closest('.page_block')
                // .find('.mvc_report')
                .find('input:radio[value="Y"]')
                .trigger('click');
            $('.btn-approve').prop('disabled', false);
        });

        // Reject all button clicked
        $(document).on('click', '#btn-reject-all', function () {
            $('input:radio[value="N"]').trigger('click');
            $('.btn-approve').prop('disabled', false);
        });

        // Waitlist all button clicked
        $(document).on('click', '#btn-waitlist-all', function () {
            $('input:radio[value="W"]').trigger('click');
            $('.btn-approve').prop('disabled', false);
        });

        $(document).on('click', '.mark_all_block_items_rejected', function() {
            $(this).closest('.page_block')
                // .find('.mvc_report')
                .find('input:radio[value="N"]')
                .trigger('click');
            $('.btn-approve').prop('disabled', false);
        });

        $(document).on('click', 'input:radio[value="Y"]', function () {
            $(this).closest('tr').removeClass().addClass(role+'_approved').find('.not_in_planogram_reason').find('textarea').prop('required', true);
            let item = $(this).closest('tr').data('item');
            $(this).closest('tr').nextAll('.reject_reason.'+item).hide();
            $(this).closest('tr').nextAll('.approve_fields.'+item).show();
            $(this).closest('tr').find('.reassign').prop('checked',false);
            $('.btn-approve').prop('disabled', false);
        });

        $(document).on('click', 'input:radio[value="N"]', function () {
            $(this).closest('tr').removeClass().addClass(role+'_rejected').find('.not_in_planogram_reason').find('textarea').prop('required', false);
            let item = $(this).closest('tr').data('item');
            $(this).closest('tr').nextAll('.reject_reason.'+item).show();
            $(this).closest('tr').nextAll('.approve_fields.'+item).hide();
            $(this).closest('tr').find('.reassign').prop('checked',false);
            $('.btn-approve').prop('disabled', false);
        });

        $(document).on('click', 'input:radio[value="W"]', function () {
            $(this).closest('tr').removeClass().addClass(role+'_waitlisted').find('.not_in_planogram_reason').find('textarea').prop('required', true);
            let item = $(this).closest('tr').data('item');
            $(this).closest('tr').nextAll('.reject_reason.'+item).hide();
            $(this).closest('tr').nextAll('.approve_fields.'+item).hide();
            $(this).closest('tr').find('.reassign').prop('checked',false);
            $('.btn-approve').prop('disabled', false);
        });

        $(document).on('click', '#btn-reset', () => {
            abcsetup.promo.workflow.resetForm(role);
            $('.btn-approve').prop('disabled', true);
        });


        $(document).on('click', '.unmark_all_block_items', function() {
            const page_block_form = $(this)
                .closest('.page_block')
                .find('.mvc_report table');
            page_block_form.find('input:checked').prop('checked', false);
            page_block_form.find('tr')
                .removeClass(`${role}_rejected ${role}_approved`)
                .next('.reject_reason')
                .hide();
            $('.btn-approve').prop('disabled', true);
        });

        $(document).on('click', '.reassign', function () {
            let disabled = true;
            const elem = $(this);
            elem.closest('tr').removeClass(`${role}_rejected ${role}_approved`).next('tr.reject_reason').hide();
            elem.closest('tr').find('.approve_reject').prop('checked', false);
            $('.reassign').each(function () {
                if ($(this).is(':checked'))
                    disabled = false;
            });

            $('.btn-reassign').prop('disabled', disabled);
        });

        $(".reject_reason_input :checkbox").change(function () {
            $(this).closest(".reject_reason_input").find(".reject_reason_text").toggle();
            if ($(this).val() === 'other')
                $(this).closest(".reject_reason_input").find(".reject_reason_text").find('textarea').prop('required', true);
        });

        $(document).on('keyup', '.page_block_proposed_cost', function() {
            const cost = $(this).val();
            if($.isNumeric(cost) === true)
                $(this).next('div.cost_cm_proposed_comment').show().find('textarea.cost_proposed_comment').prop('required',true);
            else
                $(this).next('div.cost_cm_proposed_comment').hide().find('textarea.cost_proposed_comment').prop('required',false);
        });

        $(document).on('submit', 'form', function () {
            if($(document.activeElement).val() === 'cancel')
                return true;

            const rejected = $(`.${role}_rejected:not(.reviewed)`);
            const approved = $(`.${role}_approved:not(.reviewed)`);
            let hasErrors = false;
            if (rejected.length > 0) {
                rejected.each(function () {
                    let reasons = 0;
                    let item_id = $(this).data('item');
                    $(this).next().find('input[type=checkbox]').each(function () {
                        if ($(this).is(':checked'))
                            reasons++;
                    });
                    if (reasons === 0) {
                        hasErrors = true
                        $(this).next('tr').find('div.alert').show();
                        $([document.documentElement, document.body]).animate({
                            scrollTop: $(this).offset().top
                        }, 1000);
                        return false;
                    }
                });

                if(hasErrors)
                    return false;
            }
            if (approved.length > 0) {
                approved.each(function () {
                    let item_id = $(this).data('item');
                    let month = $(this).nextAll('.approve_fields.'+item_id).find('select').val();
                    if (month == '') {
                        hasErrors = true
                        $(this).nextAll('.approve_fields.'+item_id).find('div.alert').show();
                        $([document.documentElement, document.body]).animate({
                            scrollTop: $(this).offset().top
                        }, 1000);
                        return false;
                    }
                });

                if(hasErrors)
                    return false;
            }

            return true;
        });

        $(document).on('click', '.promo_items', function() {
            var promoitems = JSON.parse($(this).find('textarea.promo_item_object').html());
            $('#item-modal').find('#results').html('');
            abcsetup.promo.workflow.renderItems(promoitems);
            $('#item-modal').modal('show');
        });

        // Remove item button clicked
        $(document).on('click', '.btn.btn-remove-item', function (e) {
            let promo_id = $('input[name="promo_id"]').val();
            let item = $(this).data('item_id');
            let _this = $(this);
            abcsetup.alerts.confirm('Delete Item', 'Are you sure you want to remove this item?', function (resp) {
                if (resp) {
                    abcsetup.blockUI(true);
                    axios.delete('/api/promoitem/delete?promo_id='+promo_id+'&item='+item)
                        .then(response => {
                            abcsetup.unblockUI();
                            _this.closest('tr.first').fadeOut('slow', function() {
                                $(this).remove();

                                if ($('#new_items_table tr').length <= 2) {
                                    $('#new_items_table').hide();
                                }
                        })
                        .catch(error => {
                            abcsetup.unblockUI();
                            abcsetup.alerts.error('Error', `An error occurred while removing the item. ${error.response.data.message}. Please contact support for assistance.`);
                        });
                    });
                }
            });
        });
    },

    fieldError: function () {
        var errorField = $('form.manage-promotions').find('.invalid').first();

        // Focus on the tab where the error occurred
        var tab = errorField.closest('div.tab-pane');
        if (!tab.hasClass('active')) {
            $('div.tab-pane').removeClass('active').removeClass('show');
            $("li.nav-item > a").removeClass('active').removeClass('show');
            tab.addClass('active').addClass('show')
            $("li.nav-item #" + tab.attr('id') + "-tab").addClass('active').addClass('show');
            errorField.trigger('focus');
        }
    },

    markAllReassign: function(elem,role) {
        // first clear approve_reject states
        elem.closest('table').find('tr').removeClass(`${role}_approved ${role}_rejected`).find('.approve_reject').prop('checked', false);
        elem.closest('table').find('tr.reject_reason').hide();
        const reassign_checkboxes = elem.closest('table').find('.reassign');
        if (elem.is(':checked')) {
            reassign_checkboxes.prop('checked', true);
            $('.btn-reassign').prop('disabled', false);
        } else {
            reassign_checkboxes.prop('checked', false);
            $('.btn-reassign').prop('disabled', true);
        }
    },

    resetForm: function(role) {
        $('form').resetForm();
        $('tr:not(.reviewed)').removeClass(`${role}_rejected ${role}_approved ${role}_waitlisted`).next('.reject_reason').hide();
        $('tr:not(.reviewed)').removeClass(`${role}_rejected ${role}_approved ${role}_waitlisted`).next('.approve_fields').hide();
        $('input[type=checkbox], input[type=radio]').prop('checked', false);
        $('.btn-reassign').prop('disabled', true);
    },

    /**
     *
     */
    renderItems: function(promoitem) {
        // Block the UI with a spinner
        abcsetup.blockUI(true);
            abcsetup.unblockUI();
            var html = '<div class="col-12">\
                            <table class="table table-striped table-sm table-bordered table-hover">\
                                <thead>\
                                    <tr>\
                                        <th>SAP #</th>\
                                        <th>UPC</th>\
                                        <th>COR 6-Digit Item #</th>\
                                        <th>Mfg. Part Number</th>\
                                        <th>Description</th>\
                                        <th>Category</th>\
                                        <th>Mat. Status</th>\
                                        <th>In Planogram</th>\
                                        <th>Predom. Planogram</th>\
                                        <th>Sales Dollars</th>\
                                        <th>Sales Units</th>\
                                        <th>Indep. Sales Dollars</th>\
                                        <th>Indep. Sales Units</th>\
                                        <th>TPR Sales Dollars</th>\
                                        <th>TPR Sales Units</th>\
                                        <th>#TPR Stores</th>\
                                    </tr>\
                                </thead>';

            $(promoitem).each(function() {
                var abc_item = this;
                console.log('abc_item: ',abc_item);
                var row_class = '';
                html = html + '<tr class="' + row_class + '">\
                                    <td>' + abc_item.sap_num + '</td>\
                                    <td>' + ((abc_item.upc11 != null) ? abc_item.upc11 : '') + '</td>\
                                    <td>' + ((abc_item.abc_6_digit != null) ? abc_item.abc_6_digit : '') + '</td>\
                                    <td>' + ((abc_item.mfr_prod_code != null) ? abc_item.mfr_prod_code : '') + '</td>\
                                    <td>' + ((abc_item.mat_descr != null) ? abc_item.mat_descr : '') + '</td>\
                                    <td>' + ((abc_item.category_name != null) ? abc_item.category_name : '') + '</td>\
                                    <td>' + ((abc_item.mat_status != null) ? abc_item.mat_status : '') + '</td>\
                                    <td>' + ((abc_item.planogram != null) ? abc_item.planogram : '') + '</td>\
                                    <td>' + ((abc_item.pog_predom != null) ? abc_item.pog_predom : '') + '</td>\
                                    <td>' + ((abc_item.annual_sales_dollars != null) ? abc_item.annual_sales_dollars : '') + '</td>\
                                    <td>' + ((abc_item.annual_sales_units != null) ? abc_item.annual_sales_units : '') + '</td>\
                                    <td>' + ((abc_item.independent_sales_dollars != null) ? abc_item.independent_sales_dollars : '') + '</td>\
                                    <td>' + ((abc_item.independent_sales_units != null) ? abc_item.independent_sales_units : '') + '</td>\
                                    <td>' + ((abc_item.tpr_sales_dollars != null) ? abc_item.tpr_sales_dollars : '') + '</td>\
                                    <td>' + ((abc_item.tpr_sales_units != null) ? abc_item.tpr_sales_units : '') + '</td>\
                                    <td>' + ((abc_item.num_tpr_stores_selling != null) ? abc_item.num_tpr_stores_selling : '') + '</td>\
                                </tr>';
            });

            if (!promoitem.length) {
                html = html + '<tr><td colspan="18" width="100%">No Items found</td></tr>';
            }

            html = html + '</table></div>';
            $('#item-modal').find('#results').html(html);
            var body = $('#item-modal').find('#results tbody');
            body.unhighlight();
    },
}
